import { Children, useState } from "react";
import styled from "styled-components";

import FileModal from "../modals/FileModal";
import Slider from "../../../ui-kits/Slider";

import laptopMock from "../../../assets/media/laptop-mockup.png";

const LaptopSlider = ({ files }) => {
  const [selectedFile, changeSelectedFile] = useState(null);

  return (
    <>
      <StyledLaptopSlider>
        <div>
          <img src={laptopMock} className="w-100" alt="" />
        </div>
        <div className="LaptopSlider_files">
          <Slider
            settings={{
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true,
              infinite: true,
            }}
          >
            {Children.toArray(
              files.map((file, index) =>
                file.includes("video") ? (
                  <div className="video_contain">
                    <div
                      className="video_contain__mask"
                      onClick={() => changeSelectedFile(index)}
                    />
                    <iframe src={file} title="laptopSlider" />
                  </div>
                ) : (
                  <div className="images_contain">
                    <img
                      src={file}
                      alt={file}
                      onClick={() => changeSelectedFile(index)}
                    />
                  </div>
                )
              )
            )}
          </Slider>
        </div>
      </StyledLaptopSlider>
      <FileModal
        isOpen={selectedFile !== null}
        selectedIndex={selectedFile}
        files={files}
        onClose={() => changeSelectedFile(null)}
      />
    </>
  );
};

export default LaptopSlider;

const StyledLaptopSlider = styled.div`
  position: relative;
  margin-bottom: 80px;

  .LaptopSlider_files {
    position: absolute;
    top: 1.8vw;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 26%);
    height: calc(100% - 47px);

    .slick-slider {
      .slick-list {
        height: 100%;

        .images_contain {
          height: calc(100% - 47px);
          overflow: hidden;

          img {
            width: 120%;
            aspect-ratio: 16/8.5;
            left: -10%;
            position: relative;
          }
        }

        .video_contain {
          height: calc(100% - 47px);
          overflow: hidden;
          position: relative;

          .video_contain__mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: transparent;
            z-index: 1003;
          }

          iframe {
            width: 120%;
            aspect-ratio: 16/8.5;
            left: -10%;
            position: relative;
          }
        }
      }

      .slick-dots {
        bottom: -70px;
      }
    }
  }

  @media (max-width: 768px) {
    .LaptopSlider_images {
      top: 5.2vw;
    }
  }
`;
